import { render, staticRenderFns } from "./cpt-chart-line.vue?vue&type=template&id=524c5340&scoped=true"
import script from "./cpt-chart-line.vue?vue&type=script&lang=js"
export * from "./cpt-chart-line.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524c5340",
  null
  
)

export default component.exports